import {zodObjectDocumentUpload} from '@/components/Helpers/validationHelpers.ts';
import type {TFunction} from 'i18next';
import {z} from 'zod';

export const form205Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        divorcedOrSeparated: z.string({message: `${t('requiredErrorFull')}`}),
        documents205: z.array(zodObjectDocumentUpload).nullish(),
    });
